import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const defaults = {
  logo: "/media/kaos-wordmark.jpg",
  favicon: "/favicon.png",
  home_video_1: "/media/home-preview-9683.mp4",
  home_video_2: "/media/home-preview-9686.mp4",
  home_video_3: "/media/home-preview-9576-upright.mp4",
  home_category_skincare: "/media/category-skincare.jpg",
  home_category_profumi: "/media/category-profumi.jpg",
  home_category_fragranze_ambiente: "/media/category-home-fragrance.jpg",
  home_story: "/media/about-marika.jpg",
  about_hero: "/media/about-marika.jpg",
  about_story: "/media/about-marika.jpg",
  home_inclusive: "/media/skincare-uomo-inclusive.png",
  family_01: "/media/families/family-01.jpg", family_02: "/media/families/family-02.jpg",
  family_03: "/media/families/family-03.jpg", family_04: "/media/families/family-04.jpg",
  family_05: "/media/families/family-05.jpg", family_06: "/media/families/family-01.jpg",
  family_07: "/media/families/family-02.jpg", family_08: "/media/families/family-03.jpg",
};

const SiteMediaContext = createContext({ media: (key) => defaults[key], refreshMedia: async () => {} });

export const SiteMediaProvider = ({ children }) => {
  const [items, setItems] = useState(defaults);
  const refreshMedia = async () => {
    try { const { data } = await api.get("/site-media"); setItems({ ...defaults, ...data }); } catch { /* defaults remain usable */ }
  };
  useEffect(() => {
    refreshMedia();
    const refresh = () => refreshMedia();
    window.addEventListener("kaos-site-media-updated", refresh);
    return () => window.removeEventListener("kaos-site-media-updated", refresh);
  }, []);
  useEffect(() => {
    const icon = document.querySelector("link[rel='icon']") || document.head.appendChild(document.createElement("link"));
    icon.rel = "icon"; icon.href = items.favicon;
  }, [items.favicon]);
  return <SiteMediaContext.Provider value={{ media: (key) => items[key] || defaults[key], refreshMedia }}>{children}</SiteMediaContext.Provider>;
};

export const useSiteMedia = () => useContext(SiteMediaContext);
